"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoleCreateDto = void 0;
const class_validator_1 = require("class-validator");
const mappable_base_1 = require("../../mappable.base");
const enums_1 = require("../../enums");
class RoleCreateDto extends mappable_base_1.MappableBase {
    constructor(roleOptions) {
        super();
        if (!roleOptions)
            return;
        Object.assign(this, roleOptions);
    }
    getFields() {
        return ['name', 'privileges', 'schoolId', 'userType', 'behaviorCodeTypes'];
    }
    name;
    privileges;
    behaviorCodeTypes;
    schoolId;
    userType;
}
exports.RoleCreateDto = RoleCreateDto;
__decorate([
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(64),
    __metadata("design:type", String)
], RoleCreateDto.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.ArrayUnique)(),
    (0, class_validator_1.IsEnum)(enums_1.PrivilegeEnum, { each: true }),
    __metadata("design:type", Array)
], RoleCreateDto.prototype, "privileges", void 0);
__decorate([
    (0, class_validator_1.IsNumber)({}, { each: true }),
    (0, class_validator_1.IsPositive)({ each: true }),
    __metadata("design:type", Array)
], RoleCreateDto.prototype, "behaviorCodeTypes", void 0);
__decorate([
    (0, class_validator_1.IsPositive)(),
    __metadata("design:type", Number)
], RoleCreateDto.prototype, "schoolId", void 0);
__decorate([
    (0, class_validator_1.IsEnum)(enums_1.UserTypeEnum),
    __metadata("design:type", String)
], RoleCreateDto.prototype, "userType", void 0);
